var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',_vm._b({scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"icon":"","text":""},on:{"click":_vm.hide}},'v-btn',attrs,false),[_c('v-icon',[_vm._v(" $close ")])],1)]}}]),model:{value:(_vm.showed),callback:function ($$v) {_vm.showed=$$v},expression:"showed"}},'v-snackbar',_vm.options,false),[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }